<nav
  class="anchor-navigation"
  [attr.aria-label]="ariaLabel()">
  @for (item of items(); track item.id; let first = $first) {
    <button
      class="anchor-navigation__item"
      type="button"
      [class.anchor-navigation__item--active]="isItemActive(item.id, first)"
      (click)="scrollToItem(item.id)">
      <span class="anchor-navigation__label">
        {{ item.label }}@if (item.itemsCount !== undefined) { ({{ item.itemsCount }}) }
      </span>
    </button>
  }
</nav>
